import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ProfileEditorDrawerLinkedinWrapper = styled.div`
  padding: 80px 36px 0px 36px;

  ${BREAKPOINTS.tablet} {
    padding: 45px 16px;
  }
`;